import React from 'react';
import { Link } from "react-router-dom"
const Kindergartengrade_k_subjects = () => {
  return (
    <div  className='fixed top-27 right-0 left-0 h-9 justify-center justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-gray-300 items-center z-50'>
    
    <Link to="/learning/kindergartengrade_k/kindergartengrade_keng" className='text-white text-lg flex  rounded-md px-3 pb-2 pt-2'>English Language Arts</Link>
    <Link to="/learning/kindergartengrade_k/kindergartengrade_kmath" className='text-white text-lg flex  rounded-md px-3 pb-2 pt-2'>Mathematics</Link>
    <Link to="/learning/kindergartengrade_k/kindergartengrade_kscie" className='text-white text-lg flex  rounded-md px-3 pb-2 pt-2'>Science</Link>
    <Link to="/learning/kindergartengrade_k/kindergartengrade_ksoc" className='text-white text-lg flex  rounded-md px-3 pb-2 pt-2'>Social studies</Link>
      
    </div>
  );
}

export default Kindergartengrade_k_subjects;